import React, { useContext, useEffect, useState } from "react";
import trans from "../../../../utils";
import { Input } from "../../../Helpers/Input/Input";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import Button from "../../../Helpers/Button/Button";
import { Switch } from "antd";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { popupcontext } from "../../../../context/Popupscontext";

export default function POIsAttributes({ addPOI }) {
	const [type, setType] = useState("text");
	const [attributes, setAttributes] = useState({
		name: null,
		type: null,
		value: null,
	});
	const { isEditing } = useContext(popupcontext);
	const [shownAttr, setShownAttr] = useState(
		isEditing ? addPOI?.values?.customAttributes : []
	);
	useEffect(() => {
		if (attributes.type === "boolean") {
			setAttributes((prev) => ({ ...prev, value: false }));
		}
	}, [attributes.type]);
	useEffect(() => {
		addPOI.setFieldValue(
			"customAttributes",
			shownAttr?.map((i) => {
				return i;
			})
		);
	}, [shownAttr]);

	const handleTypeChange = (e) => {
		setType(e);
		setAttributes((prev) => ({
			...prev,
			type: e,
			value: null, // Reset value when type changes
		}));
	};

	const isDisabled =
		!attributes.name ||
		!attributes.type ||
		attributes.value === null ||
		attributes.value === "";
	console.log("att", attributes);
	return (
		<>
			<div className="d-flex align-items-center">
				<p className="fs-16 fw-500 brand-700 text-capitalize me-2">
					{trans("custom attributes")}
				</p>
				<p style={{ textTransform: "capitalize", color: "#42526E" }}>
					({trans("optional")})
				</p>
			</div>
			<div className="row">
				<div className="col-lg-3">
					<Input
						title={trans("Attribute")}
						type="text"
						placeholder={trans("Enter attribute value")}
						formstyle="form-input"
						onChange={(e) =>
							setAttributes((prev) => ({ ...prev, name: e.target.value }))
						}
						value={attributes.name || ""}
					/>
				</div>
				<div className="col-lg-3">
					<InputSelect
						label="type"
						name="type"
						id="type"
						placeholder={trans("Select type")}
						onChange={handleTypeChange}
						formstyle="form-input"
						options={[
							{ label: trans("Boolean"), value: "boolean" },
							{ label: trans("Text"), value: "text" },
							{ label: trans("Number"), value: "number" },
						]}
						disabled={attributes.name === null}
						value={attributes.type || ""}
					/>
				</div>
				{type !== "boolean" && (
					<div className="col-lg-3">
						<Input
							title={trans("value")}
							type={type}
							placeholder={trans("Enter value")}
							formstyle="form-input"
							onChange={(e) =>
								setAttributes((prev) => ({
									...prev,
									value:
										attributes?.type === "number"
											? Number(e.target.value)
											: e.target.value,
								}))
							}
							value={attributes.value || ""}
						/>
					</div>
				)}
				{type === "boolean" && (
					<div className="col-lg-3">
						<label className="form-label text-capitalize">
							{trans("value")}
						</label>
						<Switch
							style={{ display: "block" }}
							onChange={(e) =>
								setAttributes((prev) => ({
									...prev,
									value: e,
								}))
							}
							checked={!!attributes.value}
						/>
					</div>
				)}
				<div className="col-lg-3">
					<Button
						type="primary"
						icon={<PlusOutlined color="#fff" />}
						text={trans("Add")}
						style={{ transform: "translateY(30px)" }}
						disabled={isDisabled}
						onClick={async () => {
							addPOI?.values?.customAttributes?.length > 0
								? setShownAttr((prev) => [...prev, attributes])
								: setShownAttr([attributes]);
							setAttributes({
								attribute: null,
								type: null,
								value: null,
							});
						}}
					/>
				</div>
			</div>
			{shownAttr?.length > 0 && (
				<div className="pois-shown-attrs">
					{shownAttr?.map((i, idx) => (
						<div className="poi-shown-attr" key={idx}>
							<div className="poi-attribute-name">
								<div>{i?.name}</div>
							</div>
							<div className="flex-between">
								<div className="poi-attribute-value">
									{i?.type === "boolean"
										? i?.value
											? trans("On")
											: trans("Off")
										: i?.value}
								</div>
								<CloseOutlined
									color="#192839"
									style={{ cursor: "pointer" }}
									onClick={() => {
										setShownAttr((prev) =>
											prev.filter((_, index) => index !== idx)
										);
										setAttributes({
											name: null,
											type: null,
											value: null,
										});
									}}
								/>
							</div>
						</div>
					))}
				</div>
			)}
		</>
	);
}
